import axios from "axios";

export const getDayVerse = async lang => {
  try {
    const res = await axios.get(
      `https://corsproxy.io/?${encodeURIComponent(`https://www.bible.com/${lang}?time=${(new Date).getTime()}`)}`,
      { withCredentials: false });


    const verseOfTheDayRegex = /"verseOfTheDay":\s*({.*?}),\s*"verseOfTheDayImageURL"/s;
    const verseOfTheDayImageURLRegex = /"verseOfTheDayImageURL":\s*"([^"]+)"/;

    const verseOfTheDayMatch = res.data.match(verseOfTheDayRegex);
    const data = verseOfTheDayMatch ? JSON.parse(verseOfTheDayMatch[1]) : null;

    const imageURLMatch = res.data.match(verseOfTheDayImageURLRegex);
    const imageURL = imageURLMatch ? imageURLMatch[1] : null;

    return {
      text: data?.content,
      reference: data?.reference?.human,
      image: imageURL,
    }
  } catch (e) {
    console.error(e);
    return null;
  }
};
